const ProtectedIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.9945 6C19.9945 6 20.494 17.5 12.0866 22C3.50606 17.5 4.00555 6 4.00555 6C8.00305 6 12.0001 2 12.0001 2C12.0001 2 15.4975 6 19.9945 6Z" fill="#6B7280"/>
    <path d="M14.913 9L10.9675 12.951L9.085 11.073L8 12.161L10.969 15.123L16 10.0855L14.913 9Z" fill="#E5E7EB"/>
  </svg>
)

export default ProtectedIcon
